import { Panel, PanelType } from "@fluentui/react";

import ContractOccurrences from "@/components/Contracts/ContractOccurrences";

interface OccurrencesPanelProps {
  contractId: string;
  isOpen: boolean;
  onDismiss: () => void;
}

export function OccurrencesPanel({
  contractId,
  isOpen,
  onDismiss
}: OccurrencesPanelProps): JSX.Element {
  return (
    <Panel
      headerText="Histórico do contrato"
      isOpen={isOpen}
      onDismiss={onDismiss}
      type={PanelType.medium}
      closeButtonAriaLabel="Fechar"
      isLightDismiss
    >
      <ContractOccurrences contractId={contractId} />
    </Panel>
  );
}
